// components
import GridPageAbstract from '../GridPageAbstract';
import { ArrangeSquare2BulkIcon } from '../../icons-lib/bulkIcons';
import config from '../../config';
import i18n from '../../i18';
import {
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    DialogActions,
    Button
} from '@mui/material';
import { HistoryLogCustomLinearIcon } from '../../icons-lib';
import CloseIcon from '@mui/icons-material/Close';
import { purple } from '@mui/material/colors';

export default class PayoutAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'payoutAccounts';
        this.Server = this.props.context.getState().server.payoutAccounts;

        this.headerStartIcon = ArrangeSquare2BulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.state = {
            ...this.state,
            isHistoryOpen: false,
            historyData: [],
            selectedPayoutAccount: null
        };

        this.handleHistoryLogOpen = this.handleHistoryLogOpen.bind(this);
        this.handleHistoryLogClose = this.handleHistoryLogClose.bind(this);

        this.searchFields = [
            'name',
            'beneficiaryName',
            'beneficiaryIban',
            'addressCountry',
            'addressCity',
            'addressZip',
            'addressStreet',
            'wallets.walletNumber'
        ];

        this.hiddenColumns = config?.hiddenColumns?.payoutAccounts || [];

        this.Head = [
            {
                id: 'wallets',
                key: 'walletNumber',
                label: 'wallets',
                from: 'wallets',
                alignRight: false,
                type: 'walletArray',
                cell: 'WalletArray',
                multiple: true,
                primary: 'walletNumber',
                secondary: 'location.email',
                display: 'walletNumber',
                filterCell: 'Context',
                filterBy: 'wallets',
                filterField: 'wallets.walletNumber',
                filterKey: 'walletNumber',
                searchType: 'server',
                searchFields: ['walletNumber', 'location.email'],
                searchController: 'wallets'
            },
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'beneficiaryName',
                label: 'beneficiaryName',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'beneficiaryIban',
                label: 'beneficiaryIban',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'payoutNotes',
                label: 'payoutNotes',
                alignRight: false,
                cell: 'Text'
            },

            {
                id: 'addressBuildingNumber',
                label: 'addressBuildingNumber',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressStreet',
                label: 'addressStreet',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressZip',
                label: 'addressZip',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressCity',
                label: 'addressCity',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressCountry',
                label: 'addressCountry',
                alignRight: false,
                cell: 'Entity',
                filterCell: 'Items',
                filterBy: 'addressCountry',
                items: config.countries
            },
            {
                id: 'chargeBearer',
                label: 'chargeBearer',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            // {
            //     id: 'bankClearingNumber',
            //     label: 'bankClearingNumber',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'bicOrBei',
            //     label: 'bicOrBei',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'instructionPriority',
            //     label: 'instructionPriority',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'serviceLevelType',
            //     label: 'serviceLevelType',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'serviceLevelValue',
            //     label: 'serviceLevelValue',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));
    }

    renderCustomMenuItems() {
        return [
            <MenuItem
                key="historyLog"
                onClick={() => this.handleHistoryLogOpen()}
            >
                <HistoryLogCustomLinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.historyLog') || 'History Logs'}
            </MenuItem>
        ];
    }

    async handleHistoryLogOpen() {
        this.setState({
            selectedPayoutAccount: this.state.menuClickItemId,
            isHistoryOpen: true
        });
        try {
            const res = await fetch(
                `/api/payout-accounts/activity-log/${this.state.menuClickItemId}`,
                { headers: { 'X-Auth-Token': localStorage.token } }
            );
            const json = await res.json();
            this.setState({ historyData: json.data });
        } catch (e) {
            console.error('Failed to load history:', e);
        }
    }

    handleHistoryLogClose() {
        this.setState({ isHistoryOpen: false, historyData: [] });
    }

    renderHistoryDialog() {
        const { isHistoryOpen, historyData, selectedPayoutAccount } =
            this.state;
        const payoutAccount = this.List.find(
            (item) => item.id === selectedPayoutAccount
        );

        const formatDate = (iso) => {
            if (!iso) return '';
            const d = new Date(iso);
            const time = d.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
            const date = d.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });
            return `${time} · ${date}`;
        };

        return (
            <Dialog
                open={isHistoryOpen}
                onClose={this.handleHistoryLogClose}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, fontSize: 20 }}>
                    {i18n.t('History Log', { name: payoutAccount?.name })}
                    <IconButton
                        aria-label="close"
                        onClick={this.handleHistoryLogClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (Old)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (New)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Date & Time')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed by')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Reason')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {historyData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <Typography color="textSecondary">
                                            {i18n.t('historyLog.noEntries')}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                            {historyData.map((row) => {
                                const isChanged =
                                    row.changedFieldOld !== row.changedFieldNew;
                                return (
                                    <TableRow key={row.id}>
                                        {/* OLD */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>
                                            {row.changedFieldOld ? (
                                                <Typography
                                                    variant="body2"
                                                    color="textPrimary"
                                                >
                                                    {row.changedFieldOld}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>
                                        {/* NEW */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>
                                            {row.changedFieldNew ? (
                                                <Typography
                                                    variant="body2"
                                                    color={
                                                        isChanged
                                                            ? 'warning.main'
                                                            : 'textPrimary'
                                                    }
                                                >
                                                    {row.changedFieldNew}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>
                                        {/* DATE */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {formatDate(row.dateCreated)}
                                            </Typography>
                                        </TableCell>
                                        {/* CHANGED BY */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: purple[600],
                                                    fontWeight: 500
                                                }}
                                            >
                                                {row.changedBy}
                                            </Typography>
                                        </TableCell>
                                        {/* REASON */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textPrimary"
                                            >
                                                {row.reason}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={this.handleHistoryLogClose}>
                        {i18n.t('Close')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderCustom() {
        return this.renderHistoryDialog();
    }
}
